// Extract a display-safe error message from an axios error / any exception.
export function errMsg(e, fallback = 'Something went wrong') {
    try {
        const d = e?.response?.data?.detail;
        if (typeof d === 'string') return d;
        if (Array.isArray(d)) {
            // Pydantic v2 validation error array
            return d.map((x) => {
                if (typeof x === 'string') return x;
                const loc = Array.isArray(x?.loc) ? x.loc.filter(Boolean).join('.') : '';
                return (loc ? `${loc}: ` : '') + (x?.msg || 'Invalid');
            }).join('; ');
        }
        if (d && typeof d === 'object') {
            return d.msg || d.detail || JSON.stringify(d);
        }
        if (typeof e?.message === 'string') return e.message;
    } catch { }
    return fallback;
}
